export default "__VITE_ASSET__CNVzsu9k__"